import Splide from "@splidejs/splide";

function initializeCustomerVoices() {
  // Set the identifier for the slider.
  const sliderIdentifier = ".customer-voices__slider";

  // Get all sliders.
  const sliders = document.querySelectorAll(sliderIdentifier);
  // Exit if there are no sliders.
  if (!sliders.length) {
    return;
  }

  // Loop through all sliders.
  sliders.forEach(function (slider) {
    // Initialize the slider and set the height of the slider to the height of the current slide.
    const customerVoices = new Splide(slider, {
      type: "loop",
      autoHeight: false,
      arrows: false,
      pagination: false,
      width: "100%",
    })
      .mount()
      .on("move resize", updateHeight);

    /**
     * Update the height of the slider to the height of the slide with the given index.
     *
     * @param int newIndex
     */
    function updateHeight(newIndex) {
      // Get the current slide element.
      const slide = customerVoices.Components.Slides.getAt(
        typeof newIndex == "number" ? newIndex : customerVoices.index
      ).slide;
      // Set the height of the slider to the height of the current slide.
      slide.parentElement.parentElement.style.height =
      slide.offsetHeight + "px";
    }

    /**
     * Update the height of the slider to the height of the current slide.
     */
    function updateInitialHeight() {
      // Get the current slide element.
      const slide = slider.querySelector(".splide__slide.is-active");
      // Set the height of the slider to the height of the current slide.
      slide.parentElement.parentElement.style.height =
        slide.offsetHeight + "px";
    }

    // Add navigation functions to the slider.
    const moveNext = () => {
      customerVoices.go('>')
      updatePaginationNumbers();
    };
    const movePrev = () => {
      customerVoices.go('<')
      updatePaginationNumbers();
    };

    /**
     * Initialize the navigation.
     */
    function initNavigation() {
      // Get the navigation element.
      const navigation = slider.querySelector('.customer-voices__navigation');
      // Exit if there is no navigation.
      if (!navigation) {
        return;
      }
      // Add event listeners to the navigation buttons.
      const next = navigation.querySelector('.customer-voices__arrow--next');
      next.addEventListener('click', moveNext);
      const prev = navigation.querySelector('.customer-voices__arrow--prev');
      prev.addEventListener('click', movePrev);
    }

    /**
     * Initialize the mobile navigation.
     */
    function initMobileNavigation() {
      // Get the navigation element.
      const navigation = slider.querySelector('.customer-voices__navigation--mobile');
      // Exit if there is no navigation.
      if (!navigation) {
        return;
      }
      // Add event listeners to the navigation buttons.
      const next = navigation.querySelector('.pagination__nav--next');
      next.addEventListener('click', moveNext);
      const prev = navigation.querySelector('.pagination__nav--prev');
      prev.addEventListener('click', movePrev);
      const start = navigation.querySelector('.pagination__nav--start');
      start.addEventListener('click', () => {
        customerVoices.go(0)
        updatePaginationNumbers();
      });
      const end = navigation.querySelector('.pagination__nav--end');
      end.addEventListener('click', () => {
        customerVoices.go(customerVoices.length - 1)
        updatePaginationNumbers();
      });
    }

    /**
     * Update the pagination numbers.
     */
    function updatePaginationNumbers(navigation) {
      const current = document.querySelector(
        ".customer-voices__navigation--mobile .pagination__num--current"
      );
      // Exit if there is no current element.
      if (!current) {
        return;
      }
      // Set the current number.
      current.innerHTML = customerVoices.index + 1;
    }

    // Set the initial height of the slider.
    updateInitialHeight();
    // Initialize the navigation.
    initNavigation();
    // Initialize the mobile mavigation.
    initMobileNavigation();
  });
}

export default initializeCustomerVoices;
